const WarningModal = (props) => {
  const { modalId, text, onClickCancel, onClickOk, selectedValue } = props;
  return (
    <>
      <div
        className="modal centered delete-modal fade"
        id={modalId}
        tabindex="-1"
        aria-labelledby={`${modalId}Label`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body" style={{ height: "unset" }}>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "600",
                }}
              >
                {text}
              </p>
            </div>
            <div className="modal-footer">
              <button
                style={{ width: "55px", height: "42px" }}
                type="button"
                className="btn btn-secondary"
                data-bs-toggle="modal"
                onClick={() => {
                  onClickCancel();
                }}
              >
                No
              </button>
              <button
                type="button"
                className="btn primary-btn ok-btn"
                data-bs-toggle="modal"
                onClick={() => {
                  onClickOk(selectedValue);
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WarningModal;
